import { Injectable, Injector } from '@angular/core';

import { gql } from 'apollo-angular';

import { BitfGraphQlService } from '@bitf/services/graph-ql/bitf-graph-ql.service';

import { IBitfGraphQlRequest } from '@interfaces';
import { Product, Catalog } from '@common/core/models';

@Injectable({
  providedIn: 'root',
})
// NOTE: Add methods following CRUD order
export class ProductsService extends BitfGraphQlService {
  constructor(public injector: Injector) {
    super(injector);
  }

  getProduct(requestParams: IBitfGraphQlRequest = {}) {
    console.log('getProduct', requestParams);
    requestParams.modelMapper = 'getProduct';
    requestParams.query = gql`
      query Query($id: Int) {
        getProduct(id: $id, defaultLanguage: "en") {
          title
          frontImage {
            image {
              filename
              desktop: fullpath(thumbnail: "product_desktop")
              desktop_15: fullpath(thumbnail: "product_desktop_15")
              mobile: fullpath(thumbnail: "product_mobile")
              mobile_15: fullpath(thumbnail: "product_mobile_15")
              mimetype
            }
          }
          primaryPackaging {
            ... on fieldcollection_ProductPackaging {
              material
              sortingDetails
              material_fr: material(language: "fr")
              sortingDetails_fr: sortingDetails(language: "fr")
              material_it: material(language: "it")
              sortingDetails_it: sortingDetails(language: "it")
              material_es: material(language: "es")
              sortingDetails_es: sortingDetails(language: "es")
            }
          }
          secondaryPackaging {
            ... on fieldcollection_ProductPackaging {
              material
              sortingDetails
              material_fr: material(language: "fr")
              sortingDetails_fr: sortingDetails(language: "fr")
              material_it: material(language: "it")
              sortingDetails_it: sortingDetails(language: "it")
              material_es: material(language: "es")
              sortingDetails_es: sortingDetails(language: "es")
            }
          }
        }
      }
    `;

    return super.query<Product>(requestParams);
  }

  // TODO pagination
  getProductListing(requestParams: IBitfGraphQlRequest = {}) {
    requestParams.modelMapper = 'getProductListing';
    requestParams.query = gql`
      query Query($first: Int, $after: Int, $filter: String) {
        getProductListing(first: $first, after: $after, filter: $filter) {
          edges {
            node {
              id
              eu_item: sku
              ean
              title
              shadeName
              segment: brandSubcategory {
                ... on object_BrandSubcategory {
                  description
                }
              }
            }
          }
          totalCount
        }
      }
    `;

    return super.query<Product[]>(requestParams);
  }

  getProductCatalog(requestParams: IBitfGraphQlRequest = {}) {
    requestParams.modelMapper = 'getCatalogListing';
    requestParams.query = gql`
      query GetCatalogListingWithDetails($filter: String) {
        getCatalogListing(sortBy: ["title"], filter: $filter) {
          edges {
            node {
              id
              title
              browsableCatalogUrl
              globalCatalog
              previewImage {
                ... on asset {
                  id
                }
              }
              brand {
                ... on object_Brand {
                  id
                  name
                }
              }
            }
          }
        }
      }
    `;

    return super.query<Catalog[]>(requestParams);
  }
}
